module.exports = __webpack_public_path__ + "static/media/17230024-gei1wSgs.e18c1f19.JPG";